import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260513_remove_unused_settings_field",
  description: "Remove unused includeRakeBracketsOnFrontOnly field from RoofSettings",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type === "ROOF_SETTINGS" || settings.type === "DORMER_SETTINGS") {
        delete settings.includeRakeBracketsOnFrontOnly;
      }
    }
    return json;
  },
};

export default migration;
